import { useState, type FormEvent } from 'react';
import { Modal } from '@/components/Modal';
import { Button } from '@/components/Button';
import { toast } from '@/state/toast';

interface Props {
  projectId: string;
  onClose: () => void;
}

const ROLES: { id: 'curator' | 'expert' | 'gip'; label: string }[] = [
  { id: 'curator', label: 'Куратор экспертизы' },
  { id: 'expert',  label: 'Эксперт по разделу' },
  { id: 'gip',     label: 'ГИП проектировщика' },
];

const EXPERT_SECTIONS = ['Геотехника', 'Верх. строение', 'Технология', 'ООС', 'Иное'];

export function InviteModal({ projectId, onClose }: Props) {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [role, setRole] = useState<'curator' | 'expert' | 'gip'>('expert');
  const [section, setSection] = useState(EXPERT_SECTIONS[0]);
  const [message, setMessage] = useState(`Здравствуйте! Приглашаю вас в проект ${projectId.slice(0, 8)} в системе Коллегиум.`);
  const [sendEmail, setSendEmail] = useState(true);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (!email.trim() || !name.trim()) return;
    setBusy(true);
    try {
      // TODO Sprint 3: реальный POST /projects/{id}/members + опц. POST /users (admin only)
      await new Promise((r) => setTimeout(r, 600));
      toast.success(`Приглашение отправлено: ${email}`);
      onClose();
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal
      title="Пригласить участника проекта"
      onClose={onClose}
      footer={
        <>
          <Button variant="ghost" onClick={onClose}>Отмена</Button>
          <Button variant="primary" onClick={(e) => submit(e as unknown as FormEvent)} disabled={!email.trim() || !name.trim() || busy}>
            {busy ? 'Отправка…' : 'Пригласить'}
          </Button>
        </>
      }
    >
      <form onSubmit={submit} className="flex flex-col" style={{ gap: 16 }}>
        <div>
          <label className="block text-xs font-semibold uppercase tracking-wider text-muted mb-1.5">Эл. почта</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="ivanov@expertise.ru"
            className="w-full bg-white text-ink border border-border rounded-btn outline-none focus:border-ink"
            style={{ padding: '10px 14px', fontSize: 14 }}
          />
        </div>
        <div>
          <label className="block text-xs font-semibold uppercase tracking-wider text-muted mb-1.5">Имя</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="И. Петров"
            className="w-full bg-white text-ink border border-border rounded-btn outline-none focus:border-ink"
            style={{ padding: '10px 14px', fontSize: 14 }}
          />
        </div>
        <div>
          <label className="block text-xs font-semibold uppercase tracking-wider text-muted mb-1.5">Роль</label>
          <select
            value={role}
            onChange={(e) => setRole(e.target.value as typeof role)}
            className="w-full bg-white text-ink border border-border rounded-btn outline-none focus:border-ink"
            style={{ padding: '10px 14px', fontSize: 14 }}
          >
            {ROLES.map((r) => <option key={r.id} value={r.id}>{r.label}</option>)}
          </select>
        </div>
        {role === 'expert' && (
          <div>
            <label className="block text-xs font-semibold uppercase tracking-wider text-muted mb-1.5">Раздел экспертизы</label>
            <select
              value={section}
              onChange={(e) => setSection(e.target.value)}
              className="w-full bg-white text-ink border border-border rounded-btn outline-none focus:border-ink"
              style={{ padding: '10px 14px', fontSize: 14 }}
            >
              {EXPERT_SECTIONS.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
        )}
        <div>
          <label className="block text-xs font-semibold uppercase tracking-wider text-muted mb-1.5">Сообщение (опц.)</label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows={3}
            className="w-full bg-white text-ink border border-border rounded-btn outline-none focus:border-ink"
            style={{ padding: '10px 14px', fontSize: 13, fontFamily: 'Inter, system-ui, sans-serif' }}
          />
        </div>
        <label className="inline-flex items-center text-muted" style={{ fontSize: 13, gap: 8, cursor: 'pointer' }}>
          <input type="checkbox" checked={sendEmail} onChange={(e) => setSendEmail(e.target.checked)} style={{ accentColor: '#F59E0B', width: 14, height: 14 }} />
          Отправить приглашение по эл. почте сейчас
        </label>
      </form>
    </Modal>
  );
}
